export default __webpack_public_path__ + "static/media/green-tick.982c83b7.svg";